const TYPES = {
  IHttpService: Symbol.for("IHttpService"),

  // System
  ISystemCodeParser: Symbol.for("ISystemCodeParser"),
  ICustomCodeCollectionParser: Symbol.for("ICustomCodeCollectionParser"),
  ISystemRepository: Symbol.for("ISystemRepository"),

  // ServiceInfo
  IServiceInfoParser: Symbol.for("IServiceInfoParser"),
  IServiceInfoRepository: Symbol.for("IServiceInfoRepository"),

  // Book
  IBookableDatesInfoParser: Symbol.for("IBookableDatesInfoParser"),
  ISeatsInfoParser: Symbol.for("ISeatsInfoParser"),
  IBookRequestParser: Symbol.for("IBookRequestParser"),
  IBookInfoParser: Symbol.for("IBookInfoParser"),
  IKakaoPayBookParser: Symbol.for("IKakaoPayBookParser"),
  ITempBookResultParser: Symbol.for("ITempBookResultParser"),
  IBookResultInfoParser: Symbol.for("IBookResultInfoParser"),
  IBookRepository: Symbol.for("IBookRepository"),
  GetBookableDatesFactory: Symbol.for("GetBookableDatesFactory"),
  GetSeatLayoutUseCase: Symbol.for("GetSeatLayoutUseCase"),
  IsDailyBookCheaperUseCase: Symbol.for("IsDailyBookCheaperUseCase"),
  HasFullyBookedDateUseCase: Symbol.for("HasFullyBookedDateUseCase"),
  BookableDatesInfoToDateInfosUseCase: Symbol.for(
    "BookableDatesInfoToDateInfosUseCase"
  ),

  // LineInfo
  ILineInfoParser: Symbol.for("ILineInfoParser"),
  ITurnParser: Symbol.for("ITurnParser"),
  IBusStopLiteParser: Symbol.for("IBusStopLiteParser"),
  ITurnLiteParser: Symbol.for("ITurnLiteParser"),
  ILineInfoLiteParser: Symbol.for("ILineInfoLiteParser"),
  ILineTypeParser: Symbol.for("ILineTypeParser"),
  ILineDistrictParser: Symbol.for("ILineDistrictParser"),
  IBusStopParser: Symbol.for("IBusStopParser"),
  IFavoriteLineParser: Symbol.for("IFavoriteLineParser"),
  IBaseParser: Symbol.for("IBaseParser"),
  IBusLocationParser: Symbol.for("IBusLocationParser"),
  ILineFareParser: Symbol.for("ILineFareParser"),
  IBookIntervalParser: Symbol.for("IBookIntervalParser"),
  IOnBoardLineParser: Symbol.for("IOnBoardLineParser"),
  IFilterParser: Symbol.for("IFilterParser"),
  IBusStopLayoutInfoParser: Symbol.for("IBusStopLayoutInfoParser"),
  IFileDownloadParser: Symbol.for("IFileDownloadParser"),
  ILineInfoRepository: Symbol.for("ILineInfoRepository"),
  ILineFareUseCase: Symbol.for("ILineFareUseCase"),
  GetBookIntervalsUseCase: Symbol.for("GetBookIntervalsUseCase"),
  IContactParser: Symbol.for("IContactParser"),
  ITmapArrivalTimeParser: Symbol.for("ITmapArrivalTimeParser"),
  ILineTurnBusStopParser: Symbol.for("ILineTurnBusStopParser"),
  IFavoriteBusStopParser: Symbol.for("IFavoriteBusStopParser"),
  IRoadEventsCollectionParser: Symbol.for("IRoadEventsCollectionParser"),
  IFullSeatLineParser: Symbol.for("IFullSeatLineParser"),
  IReportHistoryParser: Symbol.for("IReportHistoryParser"),
  ILineSearchFilterParser: Symbol.for("ILineSearchFilterParser"),

  // User
  ILoginParser: Symbol.for("ILoginParser"),
  ISocialLoginParser: Symbol.for("ISocialLoginParser"),
  INoticeConfigParser: Symbol.for("INoticeConfigParser"),
  IFindIdParser: Symbol.for("IFindIdParser"),
  IUserInfoParser: Symbol.for("IUserInfoParser"),
  ICompanyParser: Symbol.for("ICompanyParser"),
  ICoordinateParser: Symbol.for("ICoordinateParser"),
  IQrCodeParser: Symbol.for("IQrCodeParser"),
  IEmailDomainInfoParser: Symbol.for("IEmailDomainInfoParser"),
  ICertInfoParser: Symbol.for("ICertInfoParser"),
  IShouldChangePasswordInfoParser: Symbol.for(
    "IShouldChangePasswordInfoParser"
  ),
  IUserRepository: Symbol.for("IUserRepository"),
  IRemainBookCountParser: Symbol.for("IRemainBookCountParser"),
  IVerifyEmployeeNumberParser: Symbol.for("IVerifyEmployeeNumberParser"),

  // Bbs
  INoticeInfoParser: Symbol.for("INoticeInfoParser"),
  IQnaInfosCollectionParser: Symbol.for("IQnaInfosCollectionParser"),
  IQnaInfoDetailParser: Symbol.for("IQnaInfoDetailParser"),
  IVocCollectionParser: Symbol.for("IVocCollectionParser"),
  IVocDetailParser: Symbol.for("IVocDetailParser"),
  ILostFoundsCollectionParser: Symbol.for("ILostFoundsCollectionParser"),
  ILostFoundDetailParser: Symbol.for("ILostFoundDetailParser"),
  IBbsRepository: Symbol.for("IBbsRepository"),

  // Survey
  ISurveyParser: Symbol.for("ISurveyParser"),
  ISurveyTargetLineParser: Symbol.for("ISurveyTargetLineParser"),
  ILineDemandSurveyListParser: Symbol.for("ILineDemandSurveyListParser"),
  ILineDemandSurveyAnswerParser: Symbol.for("ILineDemandSurveyAnswerParser"),
  ISurveyRepository: Symbol.for("ISurveyRepository"),

  // Payment
  IPaymentInfoParser: Symbol.for("IPaymentInfoParser"),
  IPaymentDetailInfoParser: Symbol.for("IPaymentDetailInfoParser"),
  IPaymentMethodParser: Symbol.for("IPaymentMethodParser"),
  IPaymentRepository: Symbol.for("IPaymentRepository"),
  GetPaymentMethodsUseCase: Symbol.for("GetPaymentMethodsUseCase"),
  IsBookableStateUseCase: Symbol.for("IsBookableStateUseCase"),
  RequestFreeBookUseCase: Symbol.for("RequestFreeBookUseCase"),
  RequestFailFreeBookUseCase: Symbol.for("RequestFailFreeBookUseCase"),
  RequestCancelFreeBookUseCase: Symbol.for("RequestCancelFreeBookUseCase"),
  RequestKakaoPayUseCase: Symbol.for("RequestKakaoPayUseCase"),

  // Guide
  IGuideInfoParser: Symbol.for("IGuideInfoParser"),
  IGuideRepository: Symbol.for("IGuideRepository"),

  // Board
  IBoardInfoParser: Symbol.for("IBoardInfoParser"),
  IBoardRepository: Symbol.for("IBoardRepository"),

  // New Route
  INewRouteApplicationParser: Symbol.for("INewRouteApplicationParser"),
  INewRouteApplicationDetailParser: Symbol.for(
    "INewRouteApplicationDetailParser"
  ),
  INewRouteRepository: Symbol.for("INewRouteRepository"),

  // Address
  IAddressRepository: Symbol.for("IAddressRepository"),
  IAddressSearchInfoCollectionParser: Symbol.for(
    "IAddressSearchInfoCollectionParser"
  ),
  IUtmkCoordinateInfoParser: Symbol.for("IUtmkCoordinateInfoParser"),
  ICoordinateInfoParser: Symbol.for("ICoordinateInfoParser"),

  // File
  DownloadFileUseCase: Symbol.for("DownloadFileUseCase"),
  GetFileUrlUseCase: Symbol.for("GetFileUrlUseCase"),
};

export default TYPES;
